import { createFileRoute } from '@tanstack/react-router';
import { requireReleaseFlag } from '@/entities/session/lib/releaseGuard';
import { SettlementStatisticsConverterCreatePage } from '@/pages/settlement-statistics-converter/ui/SettlementStatisticsConverterCreatePage';

export const Route = createFileRoute('/_protected/settlement-statistics-converter/create')({
  component: SettlementStatisticsConverterCreatePage,
  beforeLoad: () => {
    requireReleaseFlag('settlement_statistics_converter');
  },
});
